import Immutable from 'seamless-immutable';
import { RESET_CUSTOMER_RECOVERABLE } from './../actions/customer.actions';
import * as AddressesActions from './../actions/customer.addresses.actions';
export var INITIAL_STATE = Immutable({
  filterData: {
    includeRemoved: false
  },
  selectedItemId: null
});
export default function AddressesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case AddressesActions.SET_INCLUDED_REMOVED_FILTER:
      return state.setIn(['filterData', 'includeRemoved'], payload);
    case AddressesActions.SET_SELECTED_ITEM_ID:
      return state.set('selectedItemId', payload);
    case RESET_CUSTOMER_RECOVERABLE:
    case AddressesActions.REMOVE_ADDRESSES_FILTER:
      return INITIAL_STATE;
    default:
      return state;
  }
}